import { render, staticRenderFns } from "./MdSnackbar.vue?vue&type=template&id=04c5bb1b"
import script from "./MdSnackbar.vue?vue&type=script&lang=js"
export * from "./MdSnackbar.vue?vue&type=script&lang=js"
import style0 from "./MdSnackbar.vue?vue&type=style&index=0&id=04c5bb1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports